import React from 'react';
import styled from '@emotion/styled';
import Tooltip from 'ds/components/tooltip';
import TooltipIcon from 'assets/svg/question-mark-2.svg';
import { SmallText } from 'ds/components/typography';
import { useLocale } from 'locale';

export const TooltipIconWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    padding: 0 ${theme.spacing(0.5)}
  `}
`;

export const CountTooltip = () => {
  const { t } = useLocale();

  return (
    <Tooltip
      tapThreshold={0}
      placement="left-start"
      hideArrow
      tooltip={<SmallText>{t('madadSearch.countTooltip')}</SmallText>}
    >
      <TooltipIconWrapper>
        <TooltipIcon />
      </TooltipIconWrapper>
    </Tooltip>
  );
};
